export default __webpack_public_path__ + "static/media/chatgip.aec13586.gif";